import 'jquery'
import 'alpinejs'
import '@fortawesome/fontawesome-free/js/all'
import 'slick-carousel'

$('.post-swiper').slick({
    infinite: true,
    slidesToShow: 4,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
            }
        },
    ]
});

$('.testimonials-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
});

$('.instagram-slider').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow: $('.instagram-prev'),
    nextArrow: $('.instagram-next'),
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
            }
        },
    ]
});


AOS.init({
    offset: 250, // offset (in px) from the original trigger point
    duration: 1200,
    mirror: true,
});

$(window).scroll(function(){
    if ($(window).scrollTop() >= 300) {
        $('#logo_sticky').addClass('hidden');
        $('header.banner').addClass('sticky');
    }
    else {
        $('#logo_sticky').removeClass('hidden');
        $('header.banner').removeClass('sticky');
    }
});

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function animateValue(id, start, end, duration) {
    if (start === end) return;
    var range = end - start;
    var current = start;
    var increment = end > start? 1 : -1;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = document.getElementById(id);
    var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (current == end) {
            clearInterval(timer);
        }
    }, stepTime);
}

$(window).on('scroll',function() {
    if(isInViewport(document.querySelector('#count_value'))) {
        animateValue("count_value", 1000, 3300, 1000);
        $(window).off('scroll');
    }
});